/**
 * Drafting Center 繁體中文語言包
 */
export default {
    draftingCenter: {
    // 時間格式化
        time: {
            justNow: '剛剛',
            minutesAgo: '{mins}分鐘前',
            hoursAgo: '{hours}小時前',
            yesterday: '昨天',
            daysAgo: '{days}天前',
        },

        // 導航
        allDrafts: '所有撰寫',
        loadMore: '加載更多',
        loadingMore: '加載中...',
        recentDrafts: '最近的撰寫',
        recentDraftsTooltip: '展示最近 3 天內更新的前 5 條撰寫記錄',
        allProjects: '所有專案',
        allProjectsRoot: '所有專案（根目錄）',

        // 頭部搜索和操作
        searchPlaceholder: '搜尋專案或資料夾...',
        newFolder: '新建資料夾',
        sortButton: '排序',
        total: '總計',

        // 操作
        create: '建立',
        edit: '編輯',
        delete: '刪除',
        move: '移動',
        moveTo: '移動到...',
        moveToFolder: '移動到資料夾',
        moveHere: '移動到這裡',
        save: '儲存',
        cancel: '取消',
        confirm: '確認',
        createFolder: '建立資料夾',
        goBack: '返回上一級',
        enterFolder: '進入資料夾',

        // 消息提示
        createSuccess: '建立成功',
        updateSuccess: '更新成功',
        deleteSuccess: '刪除成功',
        moveSuccess: '移動成功',
        folderDeletedSuccess: '資料夾刪除成功',
        projectDeletedSuccess: '專案刪除成功',
        deleteItemFailed: '刪除項目失敗',
        createFailed: '建立失敗，請重試',
        updateFailed: '更新失敗，請重試',
        deleteFailed: '刪除失敗，請重試',
        moveFailed: '移動失敗，請重試',
        fetchFailed: '獲取資料失敗，請重試',

        // 項目
        project: {
            name: '專案名稱',
            namePlaceholder: '請輸入專案名稱',
            description: '描述',
            descriptionPlaceholder: '為專案新增描述資訊',
            updateSuccess: '專案更新成功',
            updateFailed: '專案更新失敗',
        },

        // 專案對話框
        projectDialog: {
            title: '編輯專案資訊',
            projectName: '專案名稱',
            projectNamePlaceholder: '請輸入專案名稱（如：專利名稱 - 202510087033.2）',
            optional: '選填',
            descriptionPlaceholder: '為專案新增詳細描述資訊',
            clientTags: '客戶標籤',
            clientTagsDescription: '為專案新增客戶標籤，方便管理和篩選',
            clientTagsPlaceholder: '輸入或選擇客戶名稱',
            save: '儲存',
        },

        // 資料夾
        folder: {
            create: '建立資料夾',
            createDesc: '組織和管理您的專案',
            edit: '編輯資料夾',
            editDesc: '修改資料夾資訊',
            name: '資料夾名稱',
            namePlaceholder: '請輸入資料夾名稱',
            description: '描述',
            descriptionPlaceholder: '為資料夾新增描述資訊',
            optional: '選填',
            color: '顏色',
            colorTip: '選擇一個顏色標識資料夾',
            tags: '標籤',
            tagsTip: '為資料夾新增客戶端標籤，方便篩選',
            loadFailed: '載入資料夾清單失敗',
            inputPlaceholder: '輸入或選擇客戶端',
        },

        // 篩選
        filter: {
            keyword: '搜尋關鍵詞',
            workType: '工作類型',
            client: '客戶端',
            status: '狀態',
            clearAll: '清除篩選',
        },

        // 工作類型篩選
        workType: {
            all: '全部',
            drafting: '撰寫',
            prosecution: '審查意見答復',
            disclosure: '交底書',
            '00': '未指定',
            '01': '專利撰寫',
            '10': '審查意見答復',
            '11': '組合項目',
            '20': '交底書',
        },

        // 客戶端篩選
        clientFilter: {
            allClients: '所有客戶',
        },

        // 視圖
        view: {
            grid: '網格',
            list: '列表',
            board: '看板',
            gridView: '網格視圖',
            listView: '列表視圖',
        },

        // 排序
        sort: {
            name: '名稱',
            created: '建立時間',
            updated: '更新時間',
            asc: '升序',
            desc: '降序',
        },
        sortByUpdated: '按更新時間',
        sortByCreated: '按建立時間',
        sortByNameAsc: '按名稱升序',
        sortByNameDesc: '按名稱降序',

        // 狀態
        status: {
            draft: '撰寫中',
            processing: '處理中',
            completed: '已完成',
            failed: '失敗',
        },

        // 樣式標籤
        style: {
            standard: '標準',
            detailed: '詳細',
            concise: '簡潔',
        },

        // 對話框
        dialog: {
            moreActions: '更多操作',
            deleteConfirm: '確認刪除',
            deleteMessage: '您確定要刪除選中的項目嗎？',
            deleteMultipleWarning: '您即將刪除 <strong class="text-red-600 font-semibold">{count}</strong> 個項目。此操作無法撤銷。',
            cannotUndo: '此操作無法撤銷。',
            andMore: '還有 {count} 個...',
            deleting: '刪除中...',
        },

        // 移動到資料夾對話框
        moveDialog: {
            current: '當前位置',
            moveHereToThisLocation: '移動到此位置',
            cannotMoveHere: '不能移動到此處',
            moveTo: '移動到...',
            moveHere: '移動到這裡',
            movingProject: '正在移動「{name}」',
            item: '項',
            items: '項',
            noSubfolders: '沒有子資料夾',
            noSubfoldersDesc: '此資料夾不包含任何子資料夾',
            instructions: '操作說明',
            instructionsText: '點擊選擇，雙擊或使用箭頭進入資料夾',
            selectedDestination: '已選目標位置',
            goBack: '返回上一級',
            enterFolder: '進入資料夾',
        },

        // 空狀態
        empty: {
            noProjects: '還沒有任何專案',
            noResults: '沒有符合條件的專案',
            createFirst: '建立第一個專案',
            noItemsFound: '未找到任何項目',
        },

        // 計數格式化
        count: {
            project: '{count}個專案',
        },

        // API錯誤消息
        api: {
            fetchProjectsFailed: '獲取專案清單失敗',
            fetchRecentProjectsFailed: '獲取最近專案失敗',
            deleteProjectsFailed: '刪除專案失敗',
            updateProjectFailed: '更新專案失敗',
            moveProjectsFailed: '移動專案失敗',
            fetchFoldersFailed: '獲取資料夾清單失敗',
            fetchAllFoldersFailed: '獲取所有資料夾失敗',
            createFolderFailed: '建立資料夾失敗',
            updateFolderFailed: '更新資料夾失敗',
            deleteFoldersFailed: '刪除資料夾失敗',
            moveFolderFailed: '移動資料夾失敗',
            fetchStatsFailed: '獲取統計資料失敗',
            fetchFiltersFailed: '獲取篩選資料失敗',
        },

        // 資料夾操作訊息
        folderCreateFailed: '建立資料夾失敗',

        // 元資料操作
        metadata: {
            clickToCopyOaType: '點擊複製 OA 類型',
            clickToCopyOaNumber: '點擊複製 OA 編號',
            oaTypeCopied: 'OA 類型已複製',
            oaNumberCopied: 'OA 編號已複製',
            applicationNumberCopied: '申請號已複製',
            copyFailed: '複製失敗',
        },

        // 系統資料夾
        systemFolder: {
            name: '預設資料夾',
            description: '系統建立',
            badge: '系統',
        },

        // 分享
        share: '分享',
        shareDialog: {
            title: '分享專案',
            shareType: '分享類型',
            public: '公開',
            company: '公司',
            personal: '個人',
            permission: '權限等級',
            readOnly: '唯讀',
            canEdit: '可編輯',
            expiresAt: '過期時間',
            expiresAtPlaceholder: '選擇過期時間（不選則永不過期）',
            optional: '選填',
            selectUser: '選擇使用者',
            searchUserPlaceholder: '搜尋使用者名稱或信箱...',
            shareLink: '分享連結',
            copy: '複製',
            close: '關閉',
            createShare: '建立分享',
            createSuccess: '分享建立成功',
            createSuccessAndCopied: '分享建立成功，連結已複製到剪貼簿',
            autoCopyFailed: '連結自動複製失敗，請手動複製',
            createFailed: '分享建立失敗',
            linkCopied: '連結已複製到剪貼簿',
            copyFailed: '複製失敗',
            requireCompanyAccount: '需要企業帳號',
            publicReadOnlyHint: '公開分享只能設定為唯讀權限',
            companyIdNotFound: '無法獲取公司資訊，請聯絡管理員',
            selectUserRequired: '請選擇要分享的使用者',
            expiry7Days: '7 天',
            expiry15Days: '15 天',
            expiry30Days: '30 天',
            expiryNever: '永久',
            noUsersFound: '未找到匹配的使用者',
            sharedTo: '分享給',
            copyLink: '複製連結',
            publicHint: '任何擁有連結的人都可以檢視此專案',
            companyHint: '僅您組織內的成員可以存取',
            personalHint: '僅被邀請的人可以存取',
        },
    },
};
